var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-embed',{attrs:{"controls":"","type":_vm.typeOfPlayer,"aspect":"16by9","id":"video-modal-video","src":_vm.videoUrl,"allowfullscreen":"","allow":"autoplay; geolocation; microphone; camera"},on:{"ended":_vm.playNextVideo}})
}
var staticRenderFns = []

export { render, staticRenderFns }